/** Thrown when /auth/discover returns 200 with an `{ error: string }` body instead of `{ status }`. */
export class DiscoverApiError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'DiscoverApiError'
  }
}
